import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Button } from '../Button';
import { Tooltip, TooltipContent, TooltipPortal, TooltipTrigger } from '../Tooltip';
export const IconButton = forwardRef(({ tooltip, shortcut, icon, ...props }, ref) => (_jsxs(Tooltip, { children: [_jsx(TooltipTrigger, { asChild: true, ref: ref, children: _jsx(Button, { onlyIcon: true, leftIcon: icon, "aria-label": tooltip?.toString(), ...props }) }), _jsx(TooltipPortal, { children: _jsx(TooltipContent, { shortcut: shortcut, children: tooltip }) })] })));
IconButton.displayName = 'IconButton';
